export default __webpack_public_path__ + "static/media/brokerage_account_dark.6d015717.png";